import { ReactElement } from 'react';
import { CatToastGroup } from '@blocks-react/components/ToastGroup';
import { CatToast } from '@blocks-react/components/Toast';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import { CatIconInfo } from '@blocks-react/components/Icons/Info';
import { TOAST_VARIANT } from '../../../constants/commonConstants';
import styles from './success-error-toast.module.scss';

interface SuccessErrorToastProps {
  children: ReactElement | string;
  variant: 'success' | 'warning' | 'error' | undefined;
  toastPosition?: {
    verticalPosition: 'top' | 'bottom' | undefined;
    horizontalPosition: 'left' | 'center' | 'right' | undefined;
  };
}

export const SuccessErrorToast = ({
  children,
  variant,
  toastPosition = { verticalPosition: 'top', horizontalPosition: 'right' }
}: SuccessErrorToastProps) => {
  const { verticalPosition, horizontalPosition } = toastPosition;
  const getToastIcon = () => {
    switch (variant) {
      case TOAST_VARIANT.WARNING:
        return (
          <CatIconWarningTriangle
            className="pe-2"
            slot="before"
            color="warning"
          />
        );
      case TOAST_VARIANT.ERROR:
        return (
          <CatIconWarningCircle className="pe-2" slot="before" color="error" />
        );
      default:
        return <CatIconInfo className="pe-2" slot="before" color="success" />;
    }
  };
  return (variant as TOAST_VARIANT) === TOAST_VARIANT.NONE ? null : (
    <CatToastGroup
      verticalPosition={verticalPosition}
      horizontalPosition={horizontalPosition}
    >
      <CatToast className={styles['toast-message__width']} variant={variant}>
        <div className="d-flex">
          {getToastIcon()}
          {children}
        </div>
      </CatToast>
    </CatToastGroup>
  );
};
